module.exports = __webpack_public_path__ + "static/media/Component13–2.f0e4d47f.svg";